import { motion, useReducedMotion } from "framer-motion";

// Masked, line-by-line reveal for hero headings.
// Pass `lines` as an array of strings (each renders as its own masked line).
export const MaskedTitle = ({ lines = [], className = "", accentIndex = -1 }) => {
  const reduce = useReducedMotion();
  return (
    <h1 className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${i === accentIndex ? "text-teal" : ""}`}
            initial={reduce ? { opacity: 0 } : { y: "110%" }}
            animate={reduce ? { opacity: 1 } : { y: 0 }}
            transition={{
              duration: 0.9,
              delay: 0.15 + i * 0.11,
              ease: [0.22, 1, 0.36, 1],
            }}
            aria-hidden="true"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
};
